import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../../../context/CartContext';
import './PublicNavbar.css';

const PublicNavbar = () => {
  const { cart } = useCart();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const cartItemCount = cart.length;

  return (
    <nav className="public-navbar">
      <div className="container">
        <div className="navbar-content">
          {/* Logo */}
          <Link to="/" className="navbar-logo">
            <img src="/izzi.png" alt="IZZISHOWIN - Chicago Film Production Services" className="logo-image" />
          </Link>

          {/* Desktop Navigation */}
          <div className="navbar-links">
            <Link to="/" className="nav-link">
              Home
            </Link>
            <Link to="/locations" className="nav-link">
              Locations
            </Link>
            <Link to="/equipment" className="nav-link">
              Equipment
            </Link>
            <Link to="/talent" className="nav-link">
              Talent
            </Link>
            <Link to="/contact" className="nav-link">
              Contact
            </Link>
          </div>

          {/* Cart & Mobile Menu */}
          <div className="navbar-actions">
            <Link to="/cart" className="cart-button">
              <ShoppingCart size={20} />
              {cartItemCount > 0 && (
                <span className="cart-badge">{cartItemCount}</span>
              )}
            </Link>

            <button
              className="mobile-menu-button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <Link
              to="/"
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/locations"
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Locations
            </Link>
            <Link
              to="/equipment"
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Equipment
            </Link>
            <Link
              to="/talent"
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Talent
            </Link>
            <Link
              to="/contact"
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PublicNavbar;